import { render, staticRenderFns } from "./ParentReport.vue?vue&type=template&id=96f2f69c&scoped=true"
import script from "./ParentReport.vue?vue&type=script&lang=js"
export * from "./ParentReport.vue?vue&type=script&lang=js"
import style0 from "./ParentReport.vue?vue&type=style&index=0&id=96f2f69c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f2f69c",
  null
  
)

export default component.exports